//热门推荐
<template>
  <div class="hot2">
    <div class="title">
      最新评论
    </div>
    <div v-for="(item,index) in list" :key="index" class="box1">
      <div class="imgBox">
        <img v-if="item.USER_PHOTO" :src="item.USER_PHOTO" alt="">
        <img v-else :src="noIMG">
      </div>
      <span class="userName">{{ item.USER_NAME }}</span>
      <span class="times1">{{ item.CREATE_DATE }}</span>
      <p class="content">
        {{ item.SPEAK_CONTENT }}
      </p>
      <div class="component">
        <span>评论于</span><span class="componentName" @click="goDetial(item.CONTENT_ID,item.SPEAK_IS_TYPE,item.SHOW_RES_TYPE)">{{ item.CONTENT_TITLE }}</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['list'],
  data() {
    return {
      noIMG: require('@/static/usuerDefault.png')
    }
  },
  created() {
    // console.log(this.list)
  },
  methods: {
    goDetial: function(contentId, contentType, type) {
      if (contentType !== '1') {
        const { href } = this.$router.resolve({
          path: '/Detail',
          name: 'dt',
          query: {
            contentId
          }
        })
        window.open(href, '_blank')
      } else {
        const { href } = this.$router.resolve({
          url: '/sourceView',
          name: 'sourceView',
          query: {
            sourceId: contentId,
            type
          }
        })
        window.open(href, '_blank')
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .hot2{
        background-color: #fff;
        padding-bottom: 10px;
        overflow: hidden;
        padding-top: 10px;
        margin-top: 10px;
        margin-bottom: 20px;
        .title{
            height: 20px;
            line-height: 20px;
            border-left: 2px solid #ed4040;
            padding-left: 10px;
            font-size: 16px;
            margin-left: 20px;
            margin-bottom: 10px;
        }
        .box1{
            width: 270px;
            overflow: hidden;
            margin-left: 20px;
            border-top: 1px solid #e6e6e6;
            padding: 20px 0;
            .imgBox{
                display: inline-block;
                vertical-align: middle;
                img{
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                }
            }
            .userName{
                color: #999999;
                font-size: 14px;
                display: inline-block;
                vertical-align: middle;
                margin-left: 5px;
                margin-top: -5px;
            }
            .times1{
                color: #999999;
                font-size: 14px;
                display: inline-block;
                vertical-align: middle;
                float: right;
                margin-top: 5px;
            }
            .content{
                line-height: 40px;
                position: relative;
                margin-top: 8px;
                min-height: 40px;
                font-size: 14px;
                color: #333333;
                text-indent:1em;
                background-color: #f7f7f7;
            }
            .content::after{
                content: '';
                display:block;
                position: absolute;
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right:  8px solid transparent;
                border-bottom: 5px solid #f7f7f7;
                top: -5px;
                left: 10px;
            }
            .component{
                margin-top: 20px;
              span{
                  color: #b2b2b2;
                  font-size: 12px;
                  margin-left: 2px;
              }
                .componentName{
                    margin-left: 10px;
                    cursor: pointer;
                  &:hover{
                    color: #ed4040;
                  }
                }
            }
        }
    }
</style>
